import React, { useEffect, useState } from "react";
import { Service } from "../_generated";
import axios from "axios";
import { BackendURL } from "../globals";
import { authToken } from "../components/Authentication";
import LogsView from "../components/LogsView";
import { TextField, MenuItem, Grid } from "@material-ui/core";
import analytics from "../analytics";

export default function EnvironmentLogsPage({
  projectName,
  environmentPk,
}: {
  projectName: string;
  environmentPk: number | undefined;
}) {
  const [services, setServices] = useState([] as Service[]);
  const [selectedServiceName, setSelectedServiceName] = useState("");
  const apiRoot = `${BackendURL}/api`;
  const [logsUrl, setLogsUrl] = useState("");
  const servicesUrl = `${apiRoot}/projects/${projectName}/services/`;

  axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

  useEffect(() => {
    analytics.page("EnvironmentLogs");
  }, []);

  useEffect(() => {
    axios.get(servicesUrl).then((response) => {
      setServices(response.data.results);
      let servicePk = response.data.results[0].pk;
      setSelectedServiceName(response.data.results[0].name);
      let url = `${apiRoot}/projects/${projectName}/environments/${environmentPk}/services/${servicePk}/logs/`;
      setLogsUrl(url);
    });
  }, [servicesUrl, apiRoot, environmentPk, projectName]);

  // const handleClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
  //   // setAnchorEl(event.currentTarget);
  //   const element = event.target as HTMLInputElement
  //   console.log(element.value)
  //   const service = services[parseInt(element.value)] as Service
  //   console.log(service)
  //   setSelectedServiceName(service.name)
  // };

  return (
    <>
      <Grid container>
        <TextField
          select
          variant="outlined"
          value={selectedServiceName}
          label="Service"
          style={{ minWidth: "200px", marginBottom: "20px" }}
        >
          {services.map((service) => (
            <MenuItem
              key={service.pk}
              value={service.name}
              onClick={(e) => {
                setSelectedServiceName(service.name);
                setLogsUrl(
                  `${apiRoot}/projects/${projectName}/environments/${environmentPk}/services/${service.pk}/logs/`
                );
              }}
            >
              {service.name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <LogsView url={logsUrl} />
    </>
  );
}
